import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../../../../config';

export function useWorkflowSuiteSchedule() {
  return useQuery({
    queryKey: ['workflow-suite-schedule'],
    queryFn: async () => {
      const res = await fetch(
        `${API_URL}/schedules?orgId=all&jobType=benchmark.workflow-suite`,
        { credentials: 'include' },
      );
      if (!res.ok) return { schedule: null };
      const data = await res.json() as {
        schedules: Array<{ id: string; jobType: string; enabled: boolean; name: string; nextRunAt: string | null }>;
      };
      return { schedule: data.schedules[0] ?? null };
    },
    staleTime: 60_000,
  });
}
